jQuery(document).ready(function ($) {
    if(!$('.posts').length) return;

    $('.posts .post_ajax_title').click(function (e) {
        e.preventDefault();

        let tabs = $(this).closest('.posts').find('.selected'),
            current_tab = $(this).closest('.selected');

        if(!current_tab.hasClass('active')) {
            tabs.not(current_tab).removeClass('active');
            current_tab.addClass('active');
        } else {
            current_tab.removeClass('active');
        }

        scrollToEl(current_tab);
    });

    let hash = window.location.hash;
    if(hash != '') {
        let tab = $(hash).closest('.selected');
        if(tab.length) tab.find('.switch_tabs').trigger('click');
    }
});
